import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { isReactComponent } from ".";
import {
  GrapesEditor,
  GrapesTypes,
  LoadComponentOptions,
} from "../../defenitions";
import NoActionUnsubscribeComponent from "../../../Base/NoActionUnsubscribe";
import { Provider } from "react-redux";
import store from "../../../../store/store";


type ButtonConsentProps = {
  buttonText: string;
  message: string
};

export const NoActionUnsubscribe = (props: ButtonConsentProps): JSX.Element => {

 
  return (
    <Provider store={store}>
          <NoActionUnsubscribeComponent />
        </Provider>
  );
};

export default function (
  editor: GrapesEditor,
  options: LoadComponentOptions
): void {
  const domComponents = editor.DomComponents;
  const blockManager = editor.BlockManager;
  const defaultType = domComponents.getType("default");
  const { model, view } = defaultType;
  const compName = "NoActionUnsubscribe";

  blockManager.add(GrapesTypes.NoActionUnsubscribe, {
    label: "No action unsubscribe",
    category: options.categoryLabel,
    attributes: { class: "fa fa-bookmark" },
    textable: 1,
    content: `<span data-gjs-type="${GrapesTypes.NoActionUnsubscribe}"></span>`,
  });



  

  const traits = [
   
    {
      label: "Message text",
      name: "message",
      changeProp: 1,
    },

  ];


  domComponents.addType(GrapesTypes.NoActionUnsubscribe, {
    isComponent(el: HTMLElement) {
      if (
        (el.getAttribute &&
          el.getAttribute("data-gjs-type") ===
            GrapesTypes.NoActionUnsubscribe) ||
        (el.attributes &&
          (el.attributes as any)["data-gjs-type"] ===
            GrapesTypes.NoActionUnsubscribe) ||
        isReactComponent(el, compName)
      ) {
        return {
          type: GrapesTypes.NoActionUnsubscribe,
        };
      }
    },
    model: {
      defaults: {
        ...model.prototype.defaults,
        droppable: false,
        draggable: true,
        message: "Thank you!",
        traits: [...model.prototype.defaults.traits, ...traits],
      },
    },
    view: view.extend({
      init() {
        traits.forEach((trait) => {
          this.listenTo(this.model, `change:${trait.name}`, this.handleChanges);
        });
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      handleChanges(e: any, value: any) {
        ReactDOM.unmountComponentAtNode(this.el);
        this.render();
      },
      onRender() {
        const { el } = this;
        const comps = this.model.get("components");

        comps.reset();

        const compString = `<${compName}></${compName}>`;
        comps.add(compString);

        ReactDOM.render(<Provider store={store}>
          <NoActionUnsubscribeComponent/>
        </Provider>, el);
      },
    }),
  });
}
